export default "__VITE_ASSET__BdcDHdzJ__"